import { useSelector } from 'react-redux'
import { useQuery } from '@apollo/react-hooks'
import { GET_SCENARIO_ATTACKS } from '../../queries/scenario'

export default function AttackLayer(props) {
  const { selectedScenarioId, remoteStorage } = useSelector(state => state)

  if (remoteStorage.attacks) {
    const { loading, error } = useQuery(GET_SCENARIO_ATTACKS, {
      variables: { id: selectedScenarioId },
      onCompleted: data => {
        console.log('GET_SCENARIO_ATTACKS on completed')
        if (data && data.scenario) {
          data.scenario.attacks.map(attack => {
            const allMapObjectIds = props.draw
              .getAll()
              .features.map(item => item.id)
            if (!allMapObjectIds.includes(attack.geom_guid)) {
              const feature = JSON.parse(attack.geojson)
              feature.id = attack.geom_guid
              feature.properties = {
                ...(feature.properties || {}),
                line_color: attack.original_id
                  ? attack.line_color ||
                    feature.properties?.line_color ||
                    '#ff0000'
                  : '#3bb2d0',
              }
              props.draw.add(feature)
            }
          })
        }
      },
    })

    if (loading) return null
    if (error) return `Error! ${error}`
  }

  return null
}
